// InputProfile has no account mapping in the schema - visibility is decided by claims alone.
// Every claim is scoped as `<claim>.<account>.<client>` or `usr.<client>`, so a profile belongs
// to a client when any of its access claims ends with that client code.
export function isInputProfileVisibleForClient(profile, clientCode) {
  if (!clientCode) return false;
  return (profile.claimsCanAccess || []).some(
    (claim) => claim === `usr.${clientCode}` || String(claim).endsWith(`.${clientCode}`),
  );
}

export function filterInputProfilesForClient(profiles = [], clientCode) {
  return profiles
    .filter((profile) => profile && isInputProfileVisibleForClient(profile, clientCode))
    .sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
}
